import { typography } from './typography';
import type { ThemeOptions } from '@mui/material/styles';

/**
 * Base theme configuration shared between dark and light themes
 * Contains typography, spacing, shape, and breakpoints
 */
export const baseTheme: ThemeOptions = {
  typography,
  spacing: 8,
  shape: {
    borderRadius: 12,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
};
